<template>
  <div>
    <v-container fluid
                 class="pa-0 container-tabs"
                 :style="'background-color:' + backgroundColorTabs">
      <v-toolbar class="fin-tabs" style="background-color: transparent">
        <v-toolbar-items class="align-self-start"
                         style="background-color: transparent; max-width: 100%">
          <v-tabs v-model="tab"
                  class="py-0"
                  show-arrows
                  :height="$vuetify.breakpoint.smAndDown ? '55px' : '64px'"
                  :background-color="backgroundColorTabs"
                  :slider-size="sliderSize"
                  :slider-color="sliderColor"
                  :style="noItemTitlePadding ? '' : 'padding-left: ' + $valueByBreakpoint($finPadding.left) + '; padding-right: ' + $valueByBreakpoint($finPadding.right) "
                  @change="tabChanged"
          >
            <v-tabs-slider :color="sliderColor"/>
            <v-tab v-for="(item, index) in tabItems"
                   v-show="!item.hidden"
                   :key="item.name"
                   :id="item.id ? item.id : item.name"
                   :disabled="!!item.disabled"
                   :style="subTabs ? 'font-size: 14px' : 'font-size: 16px'">
              <fin-subscription-lock v-if="!(item.allowed === undefined || item.allowed === true)"
                                     color="fin-color-primary-dark"/>
              <span :style="'color: ' + sliderColor">{{ item.name }}
              <fin-circle v-if="item.color" :fill="item.color" :size="8" class="ml-2"/>
              </span>
            </v-tab>
          </v-tabs>
        </v-toolbar-items>
        <v-spacer/>
        <!-- actions slot used to display some kind of actions to be displayed on the right side of the tabs -->
        <v-toolbar-items class="align-self-end align-self-sm-start" style="background-color: transparent">
          <slot v-if="$vuetify.breakpoint.mdAndUp" name="actions"/>
        </v-toolbar-items>
      </v-toolbar>
    </v-container>

    <v-container fluid
                 class="py-0"
                 :style="noItemContentPadding ? 'padding: 0px' : 'padding-left: ' + $valueByBreakpoint($finPadding.left) + '; padding-right: ' + $valueByBreakpoint($finPadding.right) ">
      <slot v-if="$vuetify.breakpoint.smAndDown" name="actions"/>

      <slot name="tabcontent">
        <v-tabs-items v-model="currentTab"
                      :touchless="touchless"
                      :class="noTabPadding ? '' : subTabs ? 'mt-6 pb-4' : 'pt-8'"
                      :style="'background-color:' + backgroundColorTabItems">
          <v-tab-item :class="subTabs ? 'pa-6' : ''"
                      v-for="(item, index) in tabItems"
                      :key="item.name">
            <slot :name="index"/>
          </v-tab-item>
        </v-tabs-items>
      </slot>
    </v-container>
  </div>
</template>

<script>
//TODO Why noe v-model for selectedTab?
import FinCircle from "@/components/common/shapes/Circle"
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: "FinTabs",
  components: {FinSubscriptionLock, FinCircle},
  props: {
    /** The tab items to display (Array of objects)*/
    tabItems: {
      type: Array
    },
    /** The nr of the selected tab */
    selectedTab: {
      type: Number,
      default: 0
    },
    /** The background color of the tab container */
    backgroundColorTabs: {
      type: String,
      default: "#FFFFFF"
    },
    /** The background color of the individual tabs */
    backgroundColorTabItems: {
      type: String,
      default: "#F7F7F7"
    },
    /** The elements of the tabs */
    subTabs: {
      type: Boolean,
      default: false
    },
    /** The slider size */
    sliderSize: {
      type: Number,
      default: 4
    },
    /** The slider color */
    sliderColor: {
      type: String,
      default: "#02073a"
    },
    /** toggles padding of the tab items (title) */
    noItemTitlePadding: {
      type: Boolean,
      default: false
    },
    /** toggles padding of the tab content */
    noItemContentPadding: {
      type: Boolean,
      default: false
    },
    /** toggles padding between tabs and tab content */
    noTabPadding: {
      type: Boolean,
      default: false
    },
    /**
     * Swipe for mobile devices
     */
    touchless: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tab: this.selectedTab,
      currentTab: this.selectedTab
    }
  },
  methods: {
    tabChanged() {
      if (this.tabItems[this.tab].allowed === false) {
        this.$emit('tabChangeNotAllowed', this.tabItems[this.tab], this.tab)
        this.$nextTick(() => {
          this.tab = this.currentTab
        })
      } else {
        this.currentTab = this.tab
      }
    }
  },
  watch: {
    selectedTab(newVal) {
      //TODO sync this??
      if (newVal !== this.tab) {
        this.tab = newVal
        this.tabChanged()
      }
    },
    tab() {
      /**
       * Event triggered if tab changes
       */
      this.$emit("tabChanged", this.tab)
    }
  },
}
</script>

<style lang="scss" scoped>
.v-tab {
  font-family: $body-font-family;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  height: 40px;
  letter-spacing: normal;
  line-height: 1.38;
  margin: 0 32px 0 0;
  min-height: 100%;
  /*padding: 0 !important;*/
  text-transform: none;

  @media only screen and (max-width: 600px) {
    margin: 0 16px 0 0;
  }
}

.theme--light {
  .v-tab {
    color: $fin-color-primary-dark;
    caret-color: $fin-color-primary-dark;
  }

  .v-tabs-items {
    background-color: transparent !important;
  }
}

.theme--light.v-tabs > .v-tabs-bar {
  .v-tab:not(.v-tab--active),
  .v-tab:not(.v-tab--active) > .v-icon,
  .v-tab--disabled {
    color: $fin-color-primary-dark;
    caret-color: $fin-color-primary-dark;
  }
}

.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: none;
}

::v-deep .v-toolbar__content, ::v-deep .v-toolbar__extension {
  padding: 0 !important;
  box-shadow: 0 2px 0 0 rgba(2, 7, 58, 0.05);
}

// remove the space before the first tab
::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}


::v-deep .v-slide-group.v-item-group {
  .v-slide-group__next, .v-slide-group__prev {
    min-width: 26px !important;

    .v-icon {
      font-size: 40px;
      color: $fin-color-primary-dark !important;
    }

  }

  .v-slide-group__prev--disabled .v-icon {
    color: $fin-color-light-blue-gray !important;
  }


  .v-slide-group__next--disabled .v-icon {
    color: $fin-color-light-blue-gray !important;
  }
}
</style>
